import React, { useEffect } from 'react';
import { AuthContext } from 'context/auth/AuthContext';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { logout } from 'redux/slices/authSlice';
import { restoreSession } from 'redux/slices/tokenSlice';
import BackdropLoading from 'components/Loading/BackdropLoading';
import { authSelector, tokenSelector } from 'redux/selectors';
import { pathnames } from 'routes/routes';
import defaults from 'config';
import { STATUS } from 'constants/thunkStates';

function AuthProvider({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user, status: authStatus } = useSelector(authSelector);
  const { token, status: tokenStatus } = useSelector(tokenSelector);

  //? MULTIPLE TABS LOGOUT
  window.addEventListener('storage', (event) => {
    if (event.key === defaults.logoutKey) {
      dispatch(logout());
    }
  });

  useEffect(() => {
    if (authStatus === STATUS.success && user) return; // user logged in correctly
    if (!pathnames.includes(location.pathname)) return; // only try to restore session in valid paths

    // validate recovered token (on store init) and restore session
    if (tokenStatus === STATUS.idle && token) {
      dispatch(restoreSession());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStatus, user, tokenStatus, token, dispatch]);

  return (
    <AuthContext.Provider value={user}>
      {(tokenStatus === 'pending' || authStatus === 'pending') && (
        <BackdropLoading />
      )}
      {children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;
